import { render } from "./phonePage.vue?vue&type=template&id=109264ac&scoped=true"
import script from "./phonePage.vue?vue&type=script&lang=js"
export * from "./phonePage.vue?vue&type=script&lang=js"

import "./phonePage.vue?vue&type=style&index=0&id=109264ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109264ac"]])

export default __exports__